import { render } from "./DeepSeaNav.vue?vue&type=template&id=4e871b3c&scoped=true"
import script from "./DeepSeaNav.vue?vue&type=script&lang=js"
export * from "./DeepSeaNav.vue?vue&type=script&lang=js"

import "./DeepSeaNav.vue?vue&type=style&index=0&id=4e871b3c&scoped=true&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e871b3c"]])

export default __exports__